import * as ActionTypes from './types';

export function getPersons(payload) {
  return {
    type: ActionTypes.GET_PERSONS,
    payload: payload
  }
}

export function getPersonsSuccess(payload) {
  return {
    type: ActionTypes.GET_PERSONS_SUCCESS,
    payload: payload
  }
}

export function getPersonsFail(payload) {
  return {
    type: ActionTypes.GET_PERSONS_FAIL,
    payload: payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/persons.js